import { render, staticRenderFns } from "./PunishAdd.vue?vue&type=template&id=789f4597&scoped=true"
import script from "./PunishAdd.vue?vue&type=script&lang=js"
export * from "./PunishAdd.vue?vue&type=script&lang=js"
import style0 from "./PunishAdd.vue?vue&type=style&index=0&id=789f4597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789f4597",
  null
  
)

export default component.exports